import { waitLoad } from "@blax-modules/base-front-end/resources/js/utilities/load"

export class FooterAlignment {
    constructor() {
        waitLoad().then(() => {
            let that = this;
            this.init();

            window.addEventListener('resize', function(event) {
                setTimeout(() => {
                    that.init();
                }, 500);
            });
        })
    }

    init() {
        let theMax = 0;

        let els = document.querySelectorAll('.js-footer-normalize');

        els.forEach((el, index) => {
            let current = el.getBoundingClientRect().height;

            if(current > theMax){
                theMax = Math.ceil(current);
            }
        })

        if(theMax != 0){
            els.forEach((el, index) => {
                el.style.height = theMax+'px';
            })
        }

    }
}
